import React from 'react';
import { Container, Title, Text, Button, Stack, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * AccessDenied - Page shown when user tries to access unauthorized route
 */
export const AccessDenied: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const { isAdmin, isCustomer, isNonProfitUser } = useAuth();

  const handleGoBack = (): void => {
    if (isAdmin) {
      navigate('/admin');
    } else if (isNonProfitUser) {
      navigate('/nonprofit/dashboard');
    } else if (isCustomer) {
      navigate('/');
    } else {
      navigate('/login');
    }
  };

  return (
    <Container size="sm" mt="4rem">
      <Paper shadow="md" radius="md" p="xl">
        <Stack align="center" gap="lg">
          <Title order={1} fz="4rem">
            403
          </Title>

          <Title order={2}>Access Denied</Title>

          <Text c="dimmed" ta="center">
            You do not have permission to access this page. If you believe this is an error, please
            contact your administrator.
          </Text>

          <Button onClick={handleGoBack} size="lg">
            Go Back
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};
